export default {
  edit: { id: 'edit' },
  name: { id: 'name' },
  details: { id: 'details' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  monitoringAlertsTranslation: { id: 'monitoring_alerts_translation' },
  monitoringAlertsList: { id: 'monitoring_alerts_list' },
}
